











import { Component, Prop, Vue } from 'vue-property-decorator';
import type { ValidationResult } from '@/helpers/validation/Validator';

@Component({
    name: 'FormError',
    components: {},
})
export default class FormError extends Vue {
    @Prop({
        required: true,
    })
    private validation: ValidationResult;

    @Prop({
        required: true,
    })
    private field: string;

    get fieldErrors() {
        return this.validation.errors.filter((error) => error.key === this.field);
    }
}
